import { useRef, memo } from 'react';
import getComponentName from 'react-utils/getComponentName';
import refObject from '../utils/propTypes/refObject';
import { attachWrappedComponent } from './utils';

// The MemoExoticComponent type does not allow propTypes or defaultProps
// but we rely on that in several button components.
import { jsx as _jsx } from "react/jsx-runtime";
export default function (Component) {
  const ShareButtonComponent = /*#__PURE__*/memo(props => {
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      buttonRef: props.buttonRef || defaultRef
    }));
  });
  ShareButtonComponent.propTypes = Object.assign({}, Component.propTypes, {
    buttonRef: refObject
  });
  ShareButtonComponent.defaultProps = Component.defaultProps;
  ShareButtonComponent.displayName = `ShareButton(${getComponentName(Component)})`;
  attachWrappedComponent(ShareButtonComponent, Component);
  return ShareButtonComponent;
}